import FaqArticle from "./FaqArticle";

function FaqArticlesList({ faqArticles, firstArticleOpen = false }) {
  return faqArticles.map((faqArticle, index) => (
    <FaqArticle
      key={faqArticle.id}
      article={faqArticle}
      startOpen={firstArticleOpen && index === 0}
    />
  ));
}

export default FaqArticlesList;
